import React from 'react';
import BasePage from './BasePage';
import { Typography } from 'antd';

const { Title } = Typography;

const ConfiguracoesPage = () => {
    return (
        <BasePage>
            <div style={{ backgroundColor: '#FFF', padding: '20px', borderRadius: '4px' }}>
                <Title level={1}>Configurações</Title>
                <p>Conteúdo da página de Configurações será implementado aqui.</p>
            </div>
        </BasePage>
    );
};

export default ConfiguracoesPage;
